module.exports = __webpack_public_path__ + "static/12-2885344d073f26bafd1fa334ede8dca8.jpg";